// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__imdtJ","col":"styles_col__5pqM4"};